import React from 'react';
import { useTranslate } from 'ra-core';
import { useForm } from 'react-final-form';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
export const UnSavedChangesDialog = props => {
    const { onOk, onCancel, show } = props;
    const translate = useTranslate();
    const form = useForm();
    return (React.createElement(Dialog, { open: show },
        React.createElement(DialogTitle, null, translate('resources.applications.notifications.unsaved_changes')),
        React.createElement(DialogContent, null, translate('resources.applications.notifications.unsaved_changes_content')),
        React.createElement(DialogActions, null,
            React.createElement(Button, { autoFocus: true, color: "secondary", onClick: onCancel, variant: "contained" }, translate('resources.applications.actions.no')),
            React.createElement(Button, { color: "primary", onClick: () => onOk(form), variant: "contained" }, translate('resources.applications.actions.yes')))));
};
//# sourceMappingURL=UnSavedChangesDialog.js.map